import React, { useRef } from "react";
import { Printer } from "lucide-react";

import styles from "./printableTable.module.css";

const PrintableTable = ({ title, actions, children }) => {
  const tableRef = useRef();

  const handlePrint = () => {
    if (!tableRef.current) return;

     const printWindow = window.open("", "_blank");
     printWindow.document.write(`
         <html>
         <head>
             <title>Print Table</title>
             <link
             rel="stylesheet"
             href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
             />
             <style>
             @page { size: landscape; }
             table { width: 100% !important; table-layout: fixed; border-collapse: collapse; font-size: 12px; }
             th, td { border: 1px solid #000; padding: 6px; word-wrap: break-word; }
             th { background-color: #343a40; color: white; }
             tfoot { font-weight: bold; background-color: #e9ecef; }
             tr:hover { background-color: inherit; cursor: default; }
             </style>
         </head>
         <body>
             ${tableRef.current.innerHTML}
         </body>
         </html>
     `);
     printWindow.document.close();
     printWindow.focus();
     printWindow.print();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.toolbar}>
        <div className={styles.left}>
          {title && <h2 className={styles.title}>{title}</h2>}
          {actions}
        </div>
        <button type="button" className={styles.printBtn} onClick={handlePrint}>
          <Printer size={16} />
          <span>Print</span>
        </button>
      </div>

      <div ref={tableRef}>
        {children}
      </div>
    </div>
  );
};

export default PrintableTable;
